import { DomainEvent } from './DomainEvent';

export class ProductRepublishEvent extends DomainEvent {

    static eventType = 'product_republish';
    #actionType;

    constructor( actionType ) {
        super( ProductRepublishEvent.eventType );
        this.#actionType = actionType;
    }

    get actionType() {
        return this.#actionType;
    }    
}